import { Box, Button } from '@material-ui/core';
import { CSVDownloader } from 'react-papaparse';
import DescriptionIcon from '@material-ui/icons/Description';
import React, { FC } from 'react';

interface ISampleFileDownloader {
  data: { [p: string]: string }[];
}

const SampleFileDownloader: FC<ISampleFileDownloader> = (props) => {
  const { data, children } = props;

  return (
    <Box display="flex" flexDirection="column">
      {children}
      <CSVDownloader bom data={data} type="link" filename="filename">
        <Button size="small" variant="outlined" startIcon={<DescriptionIcon />}>
          Télécharger un modèle
        </Button>
      </CSVDownloader>
    </Box>
  );
};

export default SampleFileDownloader;
